import SessionStore from './sessionStore';
import UserStore from './userStore';
import CustomerStore from './customerStore';
import LibraryStore from './libraryStore';
import PresenterMeetingStore from './presenterMeetingStore';
import PublicMeetingStore from './publicMeetingStore';
import CreateMeetingStore from './createMeetingStore';
import CalendarStore from './calendarStore';
import PresenterControlStore from "./presenterControlStore";
import UserControlStore from "./userControlStore";
import ReportStore from "./reportStore";

import TodoStore from "./todoStore";
import CategoryStore from "./settings/category";
import UserSettingsStore from "./settings/userStore";
import ListSettingsStore from "./settings/list";
import GeneralSettingsStore from "./settings/generalStore";
import GeneralConfigurationStore from "./settings/configuration";
import TemplateStore from "./settings/templateStore";
import ContentViewerStore from "./contentViewerStore";
import ActivityStore from './activityStore';
import DashboardStore from './dashboardStore';

class RootStore {
  constructor() {
    this.sessionStore = new SessionStore(this);
    this.customerStore = new CustomerStore(this);
    this.libraryStore = new LibraryStore(this);
    this.presenterMeetingStore = new PresenterMeetingStore(this);
    this.publicMeetingStore = new PublicMeetingStore(this);
    this.createMeetingStore = new CreateMeetingStore(this);
    this.calendarStore = new CalendarStore(this);
    this.presenterControlStore = new PresenterControlStore(this);
    this.userControlStore = new UserControlStore(this);
    this.reportStore = new ReportStore(this);
    this.categoryStore = new CategoryStore(this);
    this.userSettingsStore = new UserSettingsStore(this);
    this.listSettingsStore = new ListSettingsStore(this);
    this.generalSettingsStore = new GeneralSettingsStore(this);
    this.configurationStore = new GeneralConfigurationStore(this);
    this.todoStore = new TodoStore(this);
    this.templateStore = new TemplateStore(this);
    this.contentViewerStore = new ContentViewerStore(this);
    this.activityStore = new ActivityStore(this);
    this.dashboardStore = new DashboardStore(this);
  }
}

const rootStore = new RootStore();
window.rootStore = rootStore;

export default rootStore;
